module.exports = __webpack_public_path__ + "images/icon_prev_5672ab0a5d3a48b93807e3ef1ddb31b2.svg";